import { toSentenceCase } from "@supliful/domain"

export const buildChoicesArray = (
  values: string[],
  options?: {
    capitalize?: boolean
    uppercase?: boolean
  },
) => {
  return values.map((value) => {
    const name = options?.uppercase
      ? value.toUpperCase()
      : options?.capitalize
        ? toSentenceCase(value)
        : value
    return {
      id: value,
      name,
    }
  })
}

export const exchange = <T>(values: T[], fromPos: number, withPos: number) => {
  const elFrom = values[fromPos]
  const elWith = values[withPos]
  const copy = [...values]
  copy[withPos] = elFrom
  copy[fromPos] = elWith
  return copy
}

export const diff = <T>(valuesBefore: T[], valuesAfter: T[]) => {
  const changes: Array<{ value: T; position: number }> = []
  valuesBefore.forEach((value, positionBefore) => {
    const positionAfter = valuesAfter.indexOf(value)
    if (positionAfter > -1 && positionAfter !== positionBefore) {
      changes.push({ value, position: positionAfter })
    }
  })
  return changes
}

export function flatten<T>(nested: T[][]) {
  return nested.reduce((all, items) => {
    if (items) {
      return all.concat(items)
    } else {
      return all
    }
  }, [])
}
